import React, { Component, createRef } from "react";
import { Layout, MTools, Player } from "@/components";
import BetterScroll from "@better-scroll/core";
import PullUp from "@better-scroll/pull-up";
import { RouteComponentProps, withRouter } from "dva/router";
import WonderfulActivities from "@/components/wonderfulActivities";
import { getBbsDetail, getVipUserList } from "@/services/service";
import styles from "./index.less";
import face from "@/assets/image/face.png";
import { Input } from "antd";

const { TextArea } = Input;

interface ForumDetailProps {}
interface ForumDetailState {
  list: any;
  loading: boolean;
  hasMore: boolean;

  topicId: string | null;
  guestList: any[];
}

type ForumDetailInfo = ForumDetailProps & RouteComponentProps;

BetterScroll.use(PullUp);

class ForumDetail extends Component<ForumDetailInfo, ForumDetailState> {
  indexRef: any;
  bs: any;
  el: any;

  constructor(props: ForumDetailInfo) {
    super(props);
    this.state = {
      list: {},
      loading: false,
      hasMore: true,
      topicId: null,
      guestList: [],
    };
    this.indexRef = createRef();
    // this.el = createRef();
  }

  componentDidMount() {
    this.getBbsDetail();
  }

  // 获取视频详情
  getBbsDetail = async () => {
    if (!this.state.hasMore) return;
    this.setState({
      loading: true,
    });

    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : "";
    const result = await getBbsDetail(Id);
    if (result.success) {
      this.setState({
        list: result.data,
        topicId: result.data.topicId || null,
      });
      this.getVipUserList(JSON.parse(result.data.activity));
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }

    this.setState({
      loading: false,
    });
  };

  // 查询嘉宾
  getVipUserList = async (activityArr: any) => {
    const result = await getVipUserList();
    if (result.success) {
      let arr: any = [];
      activityArr.map((item: any) => {
        if (
          result.data.filter((items: any) => items.id == item.sysUserId && item.list.length).length
        ) {
          arr.push(
            result.data.filter((items: any) => items.id == item.sysUserId && item.list.length)[0]
          );
        }
      });
      this.setState({
        guestList: arr,
      });
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }

    this.setState({
      loading: false,
    });
  };

  getEL = (video: any) => {
    this.el = video;
  };

  setVideoTime = (index: any) => {
    const { list } = this.state;
    const startTime = list?.outTime[index];
    if (startTime && this.el) {
      this.el.currentTime = startTime / 1000;
      this.el.play();
    }
  };

  render() {
    const { list, guestList } = this.state;
    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : null;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <Layout padding={23} share={true} businessType={2} businessId={Id}>
          {Object.keys(list).length > 0 && (
            <div className={styles.wrap}>
              <div className={styles.wrap_header}>
                <dl>
                  <dt>{list.title}</dt>
                  <dd>
                    {list?.jobId && (
                      <Player
                        getVideo={this.getEL}
                        poster={list.cover}
                        jobId={list.jobId}
                      />
                    )}
                  </dd>
                </dl>
                {guestList.length > 0 && (
                  <div className={styles.guest_data}>
                    <div className={styles.guest_data_title}>
                      <img src={face} alt="" />
                      嘉宾
                    </div>
                    {guestList.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={styles.guest_data_item}
                          onClick={() => this.setVideoTime(index)}
                        >
                          <p style={{ flexShrink: 0 }}>
                            {item.name}
                          </p>
                          <p style={{width: '70%',textAlign: 'justify'}}>{item.position}</p>
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className={styles.activity_data}>
                  {/* <div className={styles.activity_data_title}>活动介绍</div> */}
                  <TextArea
                    style={{ resize: "none" }}
                    disabled={true}
                    autoSize={true}
                    className={styles.activity_data_content}
                    value={list.summary}
                  />
                </div>
              </div>
              {/* 精彩活动 */}
              <WonderfulActivities />
            </div>
          )}
        </Layout>
      </div>
    );
  }
}

export default withRouter(ForumDetail);
